//封装和token相关的方法

const TOKENKEY = 'token_key'
const USERID = 'user_id'

function setToken(token, expire = 100) {
    const time = new Date().getTime() + expire * 60 * 60 * 1000;
    const obj = { token, time };
    localStorage.setItem(TOKENKEY, JSON.stringify(obj))
}

function getToken() {
    return localStorage.getItem(TOKENKEY)
}

function removeToken() {
    localStorage.removeItem(TOKENKEY)
    localStorage.removeItem(USERID)
}

export {
    setToken,
    getToken,
    removeToken
}